import { useMutation } from '@tanstack/react-query'
import { z } from 'zod'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { resetQueries } from '@/utils/api'
import { getApiErrorMessage } from '@/utils/error'

import { BASE_GET_GIFTCARD_BY_ID_QUERY_KEY } from './get-gift-card-by-id'
import { GET_GIFT_CARDS_BASE_QUERY_KEY } from './get-gift-cards'

export const GiftCardStatusEnum = z.enum(['redeemed', 'not-redeemed', 'expired'])

export type GiftCardStatus = z.infer<typeof GiftCardStatusEnum>

interface ChangeGiftCardStatusRequest {
  giftCardId: number
  newStatus: GiftCardStatus
}

export const changeGiftCardStatus = async ({
  giftCardId,
  newStatus,
}: ChangeGiftCardStatusRequest) => {
  const response = await authAPI.put(`/reward/${giftCardId}/status`, { status: newStatus })
  return response.data
}

export const useChangeGiftCardStatus = () => {
  return useMutation({
    mutationFn: changeGiftCardStatus,
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
    onSuccess: async () => {
      await resetQueries([BASE_GET_GIFTCARD_BY_ID_QUERY_KEY], [GET_GIFT_CARDS_BASE_QUERY_KEY])
      toastFactory.success('Status updated')
    },
  })
}
